const navMenuStyle = Object.freeze({
  buttonVariant: 'neutralOpaque',
  mobile: {
    menuFontStack: 'base',
  },
});

export default navMenuStyle;
